import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/Estadisticas.css';
import { useUserPermissions } from './UserContext';

function Estadisticas() {
    const userPermissions = useUserPermissions();
    const username = userPermissions?.username || '';
    const email = userPermissions?.email || ''; // Accede a los datos pasados
    const ruta = userPermissions?.ruta || ''; // Accede a los datos pasados
    const [temas, setTemas] = useState([]);
    const [examen, setExamen] = useState([]);

    useEffect(() => {
        // Llama a las funciones para obtener los temas y exámenes cuando el componente se monta
        if (username != '') {
            consultPerTemas();
            consultPerExamenes();
        }
    }, []); // El array vacío significa que se ejecutará solo una vez

    const consultPerTemas = async () => {
        try {
            const response = await fetch(ruta + '/estadisticas_per_temas', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ username, email })
            });

            if (response.ok) {
                const data = await response.json();
                setTemas(data);
            } else {
                console.log('Error en la respuesta del servidor.');
            }
        } catch (error) {
            console.log('Error:', error);
            // Puedes agregar una función para mostrar mensajes de error si es necesario
        }
    };

    const consultPerExamenes = async () => {
        try {
            const response = await fetch(ruta + '/estadisticas_per_examenes', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ username, email })
            });

            if (response.ok) {
                const data = await response.json();
                setExamen(data);
            } else {
                console.log('Error en la respuesta del servidor.');
            }
        } catch (error) {
            console.log('Error:', error);
            // Puedes agregar una función para mostrar mensajes de error si es necesario
        }
    };

    return (
        <>
            <div className='contenedor_principal_per'>
                <div className='row col-11 col-md-6 col-lg-6 justify-content-center'>
                <div className='titulo_e col-10 col-md-10 col-lg-10 text-center'>Estadísticas por Temas</div>
                    <div className='estadisticas_por_temas col-11 col-md-11 col-lg-11'>
                            <table className='table tabla table-striped'>
                                <thead>
                                    <tr>
                                        <th className='azul'>Tema</th>
                                        <th className='verde'>Aciertos</th>
                                        <th className='rojo'>Fallos</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {temas.map((tema, index) => (
                                        <tr key={index}>
                                            <td className='azul'>{tema.tema}</td>
                                            <td className='verde'>{tema.contador_aciertos}</td>
                                            <td className='rojo'>{tema.contador_fallos}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    </div>
                    <div className='titulo_e col-10 col-md-10 col-lg-10 text-center'>Estadísticas por Examen</div>
                    <div className='estadisticas_por_examen col-11 col-md-11 col-lg-11'>
                            <table className='table tabla table-striped'>
                                <thead>
                                    <tr>
                                        <th className='azul'>Examen</th>
                                        <th className='verde'>Aciertos</th>
                                        <th className='rojo'>Fallos</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {examen.map((examen, index) => (
                                        <tr key={index}>
                                            <td className='azul'>{examen.tema}</td>
                                            <td className='verde'>{examen.contador_aciertos}</td>
                                            <td className='rojo'>{examen.contador_fallos}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Estadisticas;
